module.exports = __webpack_public_path__ + "static/media/jCHF.b111b2e7.png";